import { padLeft } from '@scanex/utils';

const hsl2rgb = (h, s, l) => {
    let q;
    if (l < 0.5) {
        q =  l * (1.0 + s);
    }
    else if (l >= 0.5) {
        q = l + s - l * s;
    }
    let p = 2.0 * l - q;
    let hk = h / 360;
    const norm = tc => {
        if (tc < 0) return tc + 1.0;
        if (tc > 1) return tc - 1.0;
        return tc;
    };
    let tr = norm (hk + 1 / 3);
    let tg = norm (hk);
    let tb = norm (hk - 1 / 3);

    const color = tc => {
        if (tc < 1 / 6) {
            return p + ((q - p) * 6.0 * tc);
        }
        if (1 / 6 <= tc && tc < 1 / 2) {
            return q;
        }
        if (1 / 2 <= tc && tc < 2 / 3) {
            return p + ((q- p) * (2 / 3 - tc) * 6.0);
        }
        return p;
    };

    return {
        r: Math.round (color (tr) * 255),
        g: Math.round (color (tg) * 255),
        b: Math.round (color (tb) * 255)
    };
};

const rgb2hsl = (R, G, B) => {
    let r = R / 255, g = G / 255, b = B / 255;
    let max = Math.max (r, g, b);
    let min = Math.min (r, g, b);
    let h;
    if (max == min) {
        h = undefined;
    }
    else if (max == r && g >= b) {
        h = 60 * (g - b) / (max - min);
    }
    else if (max == r && g < b) {
        h = 60 * (g - b) / (max - min) + 360;
    }
    else if (max == g) {
        h = 60 * (b - r) / (max - min)  + 120;
    }
    else if (max == b) {
        h = 60 * (r - g) / (max - min) + 240;
    }
    let l = (max + min) / 2;
    let s;
    if (l == 0 || max == min) {
        s = 0;
    }
    else if (0 < l && l <= 0.5) {
        s = (max - min) / (max + min);
    }
    else if (0.5 < l && l < 1) {
        s = (max - min) / (2 - (max + min));
    }
    return {h: h, s: s, l: l};
};

const rgb2hex = (r, g, b) => {
    return `#${[r, g, b].map(x => padLeft (x.toString(16), '0', 2).toUpperCase()).join('')}`;
};

const hex2rgb = hex => {
    let [r,g,b] = /#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/gi.exec(hex).slice(1).map(x => parseInt(x, 16));
    return {r,g,b};
};

const int2hex = n => `#${padLeft(n.toString(16).toUpperCase(), '0', 6)}`;

const hex2int = hex => {
    const [h] = /^#([0-9a-f]+)$/gi.exec(hex).slice(1);
    return parseInt (h, 16);
};

export { hsl2rgb, rgb2hsl, rgb2hex, hex2rgb, int2hex, hex2int };